import { render } from "./Solution.vue?vue&type=template&id=52f863e0"
import script from "./Solution.vue?vue&type=script&lang=js"
export * from "./Solution.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__